// Mock data + pure helpers for the clerk console. Ported verbatim
// from the design reference (source/clerk-data.js). Modeled to the
// auction-runtime item.schema.json + the Velocicast clerk-screen reference.

export const CLERK_DATA = {
  event: {
    auctionName: 'Junction City Auto Auction',
    lane: 'Lane 1',
    extId: 'JCAA-2026-05-22-L1',
    clockText: '4:20:01 pm',
    streamHealth: 'healthy', // healthy | degraded | offline
  },
  stats: {
    bidders: 247,
    items: 97,
    itemsRun: 41,
    itemsSold: 33,
    itemsSoldIf: 7, // sold on IF (post-block negotiation completed)
    totalSales: 612400,
    sellThrough: 0.8,
  },
  // The item currently on block
  current: {
    id: 'item-0334',
    runNumber: '0334',
    year: 1959,
    title: 'Studebaker 4E7D (4x4)',
    vin: '1FMFK20598LA50347',
    miles: 119145,
    color: 'Black',
    seller: "Rick's Auto Sales",
    sellerBadge: 'RAS',
    consignorId: 'CG-1042',
    titleAttached: false,
    titleStatus: 'Title in transit',
    lights: ['Green', 'Y'], // green/yellow/red lane lights
    damages: [
      { id: 'd-1', location: 'Rear Bumper Cover', damage: 'Mult Dents/Paint Dmg', severity: 5, note: 'Cracked paint' },
      { id: 'd-2', location: 'LR Wheel', damage: 'Curb Rash', severity: 3, note: '5" to 6"' },
      { id: 'd-3', location: 'RF Wheel', damage: 'Curb Rash', severity: 3, note: '4" to 5"' },
      { id: 'd-4', location: 'RR Wheel', damage: 'Curb Rash', severity: 3, note: '5" to 6"' },
      { id: 'd-5', location: 'Warning · Tire Pressure', damage: 'On', severity: 4, note: 'Unacceptable' },
      { id: 'd-6', location: 'Hood', damage: 'Chipped', severity: 3 },
      { id: 'd-7', location: 'Deck Lid', damage: 'Light Mult Scratches', severity: 2 },
    ],
    announcement:
      'Frame damage left rear quarter, professionally repaired 2019 with full documentation. Vehicle runs and drives but is impaired — will start and idle for short periods only. Engine misfire on cold start, smooths out after warming up.\n\nLight scratches on multiple panels (front bumper cover, deck lid, hood, L qtr panel, LF door, LF fender). All four wheels show curb rash. Tire pressure warning illuminated.\n\nSold AS-IS with no representations or warranties as to condition or operability. Bill of sale only — title in transit, expected within 30 days.',
    photoUrl: new URL('./assets/vehicle-on-block.png', import.meta.url).href,
    // ASI vehicle metadata (Block Selling Application screen)
    lotNumber: '0025',
    lane: '11',
    stockNumber: '112793',
    cylinders: 8,
    transmission: 'A',
    airConditioning: true,
    drivetrain: '4WD',
    timesRun: 0,
    blkBook: 16100,
    fees: { sellerFee: 235, buyerFee: 185, titleFee: 65 },
    reserve: 18200,
    floorReserve: 17500,
    startingBid: 4000,
    preBids: 5,
    preBidsHighAmount: 13500,
    currentBid: 15700,
    askingBid: 15800,
    nextMinIncrement: 100,
    onlineHigh: { amount: 15800, bidder: 'Bob Stanley', badge: 'B-241', source: 'online' },
    floorHigh: { amount: 15700, bidder: 'Ted Ryerson', badge: 'F-019', source: 'floor' },
    leader: 'floor', // floor | online
    leaderSourceLabel: 'Floor',
    msrp: 28950,
    mmr: 16850,
    blackBook: 16100,
    valuationConfidence: 'good',
    // Block-rep state
    isBlockRepRequired: true,
    rep: { name: 'Heather Smith', consignor: 'Porsche of Roseville', consignorId: 'CG-1042', state: 'present' },
    repDecision: null,
  },
  // Recent bid history (newest first)
  bidHistory: [
    { id: 'b18', amount: 15800, source: 'online', bidder: 'Bob Stanley', badge: 'B-241', t: '4:20:01' },
    { id: 'b17', amount: 15700, source: 'floor', bidder: 'Ted Ryerson', badge: 'F-019', t: '4:19:58' },
    { id: 'b16', amount: 15600, source: 'online', bidder: 'Bob Stanley', badge: 'B-241', t: '4:19:54' },
    { id: 'b15', amount: 15500, source: 'floor', bidder: 'Ted Ryerson', badge: 'F-019', t: '4:19:49' },
    { id: 'b14', amount: 15400, source: 'online', bidder: 'Bob Stanley', badge: 'B-241', t: '4:19:42' },
    { id: 'b13', amount: 15300, source: 'floor', bidder: 'Ted Ryerson', badge: 'F-019', t: '4:19:36' },
    { id: 'b12', amount: 15200, source: 'online', bidder: 'Lila Pham', badge: 'B-118', t: '4:19:30' },
    { id: 'b11', amount: 15100, source: 'floor', bidder: 'Ted Ryerson', badge: 'F-019', t: '4:19:24' },
    { id: 'b10', amount: 15000, source: 'online', bidder: 'Bob Stanley', badge: 'B-241', t: '4:19:19' },
    { id: 'b09', amount: 14800, source: 'floor', bidder: 'Ted Ryerson', badge: 'F-019', t: '4:19:14' },
    { id: 'b08', amount: 14500, source: 'online', bidder: 'Lila Pham', badge: 'B-118', t: '4:19:08' },
    { id: 'b07', amount: 14200, source: 'floor', bidder: 'Ted Ryerson', badge: 'F-019', t: '4:18:59' },
  ],
  // Up-next run order
  upNext: [
    { run: '0335', year: 2007, title: 'Chevrolet Suburban 4WD Gas K10 SUV', miles: 88431, repRequired: false },
    { run: '0336', year: 2008, title: 'Ford Expedition EL 4WD 4D Utility', miles: 121040, repRequired: false },
    { run: '0337', year: 2014, title: 'Chevrolet Camaro V6 2D Coupe SS', miles: 41202, repRequired: true },
    { run: '0338', year: 2009, title: 'Audi A3 4D Hatchback 2.0T Premium', miles: 71891, repRequired: false },
    { run: '0339', year: 2007, title: 'Dodge Ram 1500 4WD Quad Cab Laramie', miles: 145002, repRequired: false },
  ],
  // Lane chat (newest at bottom)
  chat: {
    global: [
      { id: 'm1', who: 'Bob Stanley', role: 'buyer', text: 'Are the rear brakes the only damage?', t: '4:19:30' },
      { id: 'm2', who: 'You', role: 'clerk', text: 'Yes — that and the bumper scuff disclosed in Yellow light.', t: '4:19:38' },
      { id: 'm3', who: 'Heather Smith', role: 'rep', text: "I'm on the line for the Expedition.", t: '4:19:42' },
      { id: 'm4', who: 'Ted (auctioneer)', role: 'auctioneer', text: 'Copy. Standing on floor at 15.7.', t: '4:19:50' },
      { id: 'm5', who: 'You', role: 'clerk', text: 'Holding.', t: '4:19:54' },
      { id: 'm6', who: 'Bob Stanley', role: 'buyer', text: 'Bumping online to 15.8.', t: '4:19:58' },
      { id: 'm7', who: 'Maria Cruz', role: 'watcher', text: 'Any post-sale inspection allowed?', t: '4:20:04' },
      { id: 'm8', who: 'You', role: 'clerk', text: 'Yes — 30 minutes, lane 3 inspection bay.', t: '4:20:11' },
    ],
    rep: [
      { id: 'r1', who: 'Heather Smith', role: 'rep', text: 'Take it to 16.5 if you can.', t: '4:19:40' },
      { id: 'r2', who: 'You', role: 'clerk', text: 'Standing on 15.7 floor right now.', t: '4:19:55' },
    ],
  },
  // Online bidder activity for the current item.
  activity: {
    hovering: [
      { badge: 'B-241', name: 'Bob Stanley', sinceSec: 4, atSite: true },
      { badge: 'B-302', name: 'Alex Yu', sinceSec: 1, atSite: false },
    ],
    bidded: [
      { badge: 'B-241', name: 'Bob Stanley', lastBid: 15800, count: 4, t: '4:19:58', atSite: true },
      { badge: 'B-118', name: 'Dana Park', lastBid: 15500, count: 2, t: '4:19:18', atSite: false },
      { badge: 'B-076', name: 'Wei Chen', lastBid: 15300, count: 1, t: '4:18:55', atSite: true },
    ],
    viewing: [
      { badge: 'B-302', name: 'Alex Yu', atSite: false },
      { badge: 'B-211', name: 'Maria Cruz', atSite: true },
      { badge: 'B-455', name: 'Jordan Patel', atSite: false },
      { badge: 'B-088', name: 'Sam Rivera', atSite: false },
      { badge: 'B-360', name: 'Priya Shah', atSite: true },
      { badge: 'B-503', name: 'Theo Hartman', atSite: false },
      { badge: 'B-194', name: 'Lena Wu', atSite: false },
    ],
  },
};

// `buildBidPad` used to live here. It moved into the component library as
// `utils/bidPad.js`, beside the `FloorBidPad` that is its only caller — laying
// out a ladder of prices is presentation, and the pad's whole design would
// otherwise sit outside the pad.

// Runs that resolve to a foreign event (for the cross-event move flow).
export const CLERK_CROSS_EVENT = {
  '0666': { run: '0666', year: 2019, title: 'Ram 1500 4WD Crew Cab Big Horn', miles: 62110, repRequired: false, event: 'Dealer Open Sale', lane: 'Lane 3' },
  '0588': { run: '0588', year: 2016, title: 'Toyota RAV4 AWD 4D XLE', miles: 98240, repRequired: true, event: 'Fleet / Lease Remarketing', lane: 'Lane 5' },
  '0701': { run: '0701', year: 2021, title: 'Honda Civic 4D Sedan Sport', miles: 33015, repRequired: false, event: 'Online-Only Tuesday', lane: 'Digital A' },
};

// Resolve a typed run number to { kind: 'here' | 'cross' | 'none', item? }.
export function clerkLookupRun(raw, data) {
  const run = String(raw || '').trim().replace(/^#/, '');
  if (!run) return { kind: 'none' };
  const padded = run.padStart(4, '0');
  const here = new Set([String(data.current.runNumber), ...(data.upNext || []).map((r) => String(r.run))]);
  if (here.has(run) || here.has(padded)) return { kind: 'here' };
  const known = CLERK_CROSS_EVENT[run] || CLERK_CROSS_EVENT[padded];
  if (known) return { kind: 'cross', item: { ...known } };
  return {
    kind: 'cross',
    item: { run: padded, year: 2018, title: 'Chevrolet Equinox AWD 4D LT', miles: 76500, repRequired: false, event: 'Dealer Open Sale', lane: 'Lane 3' },
  };
}
